module.exports = __webpack_public_path__ + "img/FanExam_Horiz_3x_Blk_powered.a1f61ff2.png";